<template>
  <div class="flex items-center" :class="CoverStateTexteColor">
    <svg class="w-[12px] fill-current mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 79.771">
      <g transform="translate(-16 -10.229)">
        <g>
          <path
            d="M22,40H32c.521-9.561,5.6-19.948,18-19.948C61.961,20.052,67.34,31,68,40H78c-.18-17-9.34-29.608-28-29.769C31.461,10.052,22,23.281,22,40Zm-6,9.541v34C16,88.521,17.121,90,22,90H78c5.219,0,6-1.4,6-6.459v-34C84,44.623,83.08,44,78,44H22C17.18,44,16,44.881,16,49.541Zm40.359,14a6.657,6.657,0,0,1-4.34,6.271L56,80H44l3.98-10.188a6.507,6.507,0,0,1-4.34-6.156A6.4,6.4,0,0,1,50,57.238,6.3,6.3,0,0,1,56.359,63.541Z"
            fill-rule="evenodd" />
        </g>
      </g>
    </svg>
    {{ CoverStateTexte }}
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    CoverStateTexte() {
      let CoverState = this.config?.dock?.status?.cover_state

      if (CoverState == 0) {
        return "Dock fermé";
      } else if (CoverState == 1) {
        return "Dock ouvert";
      } else if (CoverState == 2) {
        return "Dock en cours d'ouverture";
      } else if (CoverState == 3) {
        return "Etat d'ouverture anormal";
      }

      return ENV.NO_DATA;
    },

    CoverStateTexteColor() {
      let CoverState = this.config?.dock?.status?.cover_state

      if (CoverState == 2) {
        return "text-warning";
      } else if (CoverState == 3) {
        return "text-error";
      }

      return "";
    }
  },
};
</script>
